import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class ShowcaseReviewsConfigDto
*  Настройки отзывов витрины для фронта.
*/
export class ShowcaseReviewsConfigDto extends ActiveModel {

  /**
  * enabled
  * Модуль включён: показывать отзывы, рейтинг и форму.  */
  @ActiveField(false)
  enabled: boolean = false


  /**
  * allowMedia
  * Фото разрешены.  */
  @ActiveField(false)
  allowMedia: boolean = false


  /**
  * maxPhotos
  * Максимум фото в одном отзыве.  */
  @ActiveField(0)
  maxPhotos: number = 0


  /**
  * allowRatingOnly
  * Можно оставить только оценку, без текста.  */
  @ActiveField(false)
  allowRatingOnly: boolean = false


  /**
  * minTextLength
  * Минимальная суммарная длина текста, если текст указан; `null` — без ограничения.  */
  @ActiveField()
  minTextLength?: null | number


  /**
  * requirePurchase
  * Отзыв только после покупки.  */
  @ActiveField(false)
  requirePurchase: boolean = false
}
